(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.getBoundingClientRect().height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Leave the header alone while the search panel is open - hide() would
      // both pull it off screen and close the search. isOpen above only covers
      // the panel once it has results, not an open panel with an empty input.
      // currentScrollTop still has to move, or the first scroll after closing
      // is measured against a stale position and reads as the wrong direction.
      if (document.body.classList.contains('search_open')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-static-page"] && !Shopify.designMode) return;
  try {
    
  class SearchableSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.trigger = this.querySelector('.ssp__searchable-select-trigger');
      this.panel = this.querySelector('.ssp__searchable-select-panel');
      this.search = this.querySelector('.ssp__searchable-select-search');
      this.valueEl = this.querySelector('.ssp__searchable-select-value');
      this.hiddenInput = this.querySelector('.ssp__searchable-select-hidden-input');
      this.options = Array.from(this.querySelectorAll('[role="option"]'));

      this.trigger.addEventListener('click', this.toggle.bind(this));
      this.search.addEventListener('input', this.filter.bind(this));
      this.options.forEach((option) => {
        option.addEventListener('click', () => this.select(option));
      });
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    toggle() {
      if (this.panel.hidden) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      this.search.value = '';
      this.filter();
      requestAnimationFrame(() => this.search.focus());
    }

    close() {
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
    }

    filter() {
      const query = this.search.value.trim().toLowerCase();
      this.options.forEach((option) => {
        option.hidden = !option.textContent.trim().toLowerCase().includes(query);
      });
    }

    select(option) {
      this.valueEl.textContent = option.textContent.trim();
      this.hiddenInput.value = option.dataset.value;
      this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.options.forEach((opt) => opt.setAttribute('aria-selected', opt === option ? 'true' : 'false'));
      this.close();
      this.trigger.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        this.trigger.focus();
      }
    }
  }

  customElements.define('searchable-select', SearchableSelect);

  } catch(e) { console.error(e); }
})();
})();
